import axios from '../../api/designBuilder/axios';
import actionTypes from './index';
import globalError from '../globalError';
import { getItemsForEstimate } from '../../selectors/getItemsForEstimate';
import config from '../../helpers/config';

export default (designId, onError) => (dispatch, getState) => {
  const { entities } = getState().estimateBuilder;

  const payload = {
    siteId: config.siteId,
    partnerProductIds: getItemsForEstimate(entities, designId)
      .filter(item => item.itemProduct)
      .map(item => item.itemProduct.skuNumber),
  };

  if (payload.partnerProductIds.length > 0) {
    const url = `${config.ProductMapApi}`;
    axios
      .post(url, payload)
      .then((response) => {
        dispatch({ type: actionTypes.UPDATE_PRODUCT_MAP, payload: response.data });
      })
      .catch((err) => {
        onError();
        dispatch(globalError({ err }));
      });
  }
};
